import { PHONE_MAX_MIN_SIDE, DESKTOP_MIN_MAX_SIDE, classifyLayout, isMobile, type Viewport } from '@aerofruits/game-shell';

function viewportMetrics(vp: Viewport): { w: number; h: number; minSide: number; maxSide: number; landscape: boolean } {
  const w = Math.max(1, vp.width);
  const h = Math.max(1, vp.height);
  return { w, h, minSide: Math.min(w, h), maxSide: Math.max(w, h), landscape: w > h };
}

/**
 * True for phone-sized touch viewports (not tablets or desktop).
 * Uses dimensions first; coarse pointer refines borderline cases.
 */
export function isMobilePhoneViewport(vp: Viewport): boolean {
  const { minSide, maxSide } = viewportMetrics(vp);
  if (maxSide >= DESKTOP_MIN_MAX_SIDE && vp.coarsePointer === false) return false;
  if (minSide <= PHONE_MAX_MIN_SIDE) return true;
  return isMobile(classifyLayout(vp));
}

/** Mobile phone in landscape — gameplay must be blocked behind the orientation overlay. */
export function isOrientationBlocked(vp: Viewport): boolean {
  const { minSide, maxSide, landscape } = viewportMetrics(vp);
  if (!landscape) return false;
  if (maxSide >= DESKTOP_MIN_MAX_SIDE) return false;
  if (minSide <= PHONE_MAX_MIN_SIDE) {
    // Desktop browsers resized to phone-like landscape should still block in showcase testing.
    if (vp.coarsePointer === false && maxSide >= 1000) return false;
    return true;
  }
  return isMobile(classifyLayout(vp));
}

/** Portrait play mode on a mobile phone. */
export function isMobilePortraitPlayable(vp: Viewport): boolean {
  const { landscape } = viewportMetrics(vp);
  if (landscape) return false;
  return isMobilePhoneViewport(vp);
}
